import { invariant } from '@e-socna/utils';

import { ReportContextStatus } from '../types/report-context.type';

import { useReportContext } from './useReportContext.hook';

export const useReportReadyContext = () => {
  const context = useReportContext();

  invariant(
    context.status === ReportContextStatus.Ready,
    'useReportReadyContext requires ReportContext to be ready',
  );

  return context;
};
